import { canActor } from '../domain/authorization'
import type { ActorContext } from '../domain/authorization'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemPort } from '../domain/workflow'

const completeWorkItem = async (
	port: WorkItemPort,
	item: WorkItem,
	ctx: ActorContext,
	notify: NotifyPort,
	phaseTeamId: string | null = null,
): Promise<WorkItem | null> => {
	if (!canActor('complete', item, ctx, phaseTeamId)) {
		notify.error('workItem.denyComplete')
		return null
	}
	try {
		const updated = await port.completeWorkItem(item.id, ctx.actorId, ctx.actorName)
		notify.success('workItem.completed')
		return updated
	} catch {
		notify.error('workItem.completeFailed')
		return null
	}
}

export { completeWorkItem }
